import { EditForm } from "./edit-form";

export const DemoGames = { EditForm };
